import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faTrashAlt } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';
import ImageDropzone from 'components/image_dropzone';

interface UploadResponse {
  id: number;
  url: string;
  file_name: string;
}

interface Props {
  bioPdfUrl: string | null;
}

export default function BioPdfUpload({ bioPdfUrl }: Props) {
  const [uploadId, setUploadId] = useState<number | null>(null);
  const [newFileName, setNewFileName] = useState<string | null>(null);
  const [deleted, setDeleted] = useState(false);

  function handleUpload(data: UploadResponse) {
    setUploadId(data.id);
    setNewFileName(data.file_name);
    setDeleted(false);
  }

  function clearNewUpload(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    setUploadId(null);
    setNewFileName(null);
  }

  function removeExisting(e: React.MouseEvent<HTMLButtonElement>) {
    e.preventDefault();
    setDeleted(true);
  }

  const showExisting = Boolean(bioPdfUrl) && !deleted && !uploadId;
  const hasCurrentPdf = Boolean(uploadId) || showExisting;

  return (
    <div>
      <ImageDropzone
        allowedMedia={['application/pdf']}
        dropBox={
          <div className="p-3 text-center text-muted">
            <FontAwesomeIcon className="me-1" icon={faFilePdf} />
            {hasCurrentPdf ? 'Drag a new PDF, or click here to replace' : 'Drag a PDF, or click here to upload'}
          </div>
        }
        dropZoneClassName="media-uploader"
        onUploadComplete={handleUpload}
      />

      {uploadId && (
        <p className="small mt-2">
          <strong className="text-primary">Bio PDF selected </strong>
          <span className="text-danger">(update user to save)</span>
          <br />
          <FontAwesomeIcon className="text-primary me-1" icon={faFilePdf} />
          {newFileName}
          <span className="text-muted"> | </span>
          <Button label="Clear" size="sm" variant="ghost" onClick={clearNewUpload} />
        </p>
      )}

      {showExisting && (
        <div className="mt-2">
          <p>
            <a href={bioPdfUrl ?? undefined}>
              <FontAwesomeIcon className="text-primary me-1" icon={faFilePdf} />
              Current Uploaded Bio
            </a>
          </p>
          <Button
            className="text-danger"
            icon={faTrashAlt}
            label="Remove Uploaded Bio"
            size="sm"
            variant="ghost"
            onClick={removeExisting}
          />
        </div>
      )}

      {uploadId && <input name="user[bio_pdf_upload_id]" type="hidden" value={uploadId} />}
      <input name="user[delete_bio_pdf]" type="hidden" value={deleted ? 'true' : 'false'} />
    </div>
  );
}
